<template>
  <v-container fluid class="px-8">
    <v-row>
      <v-col cols="6">
        <ValidationObserver v-slot="{ handleSubmit }">
          <v-form v-on:submit.prevent="handleSubmit(save)">
            <v-row>
              <v-col cols="12" class="pt-0">
                <ValidationProvider
                  rules="required"
                  name="degreeType"
                  v-slot="{ errors }"
                >
                  <v-radio-group
                    class="mt-0"
                    v-model="form.degreeType"
                    :error-messages="errors"
                    :disabled="true"
                  >
                    <v-row class="radio-group">
                      <v-col cols="6" class="px-0 py-0">
                        <v-radio
                          class="label"
                          label="De Bac à Bac+3"
                          :value="3"
                        ></v-radio>
                      </v-col>
                      <v-col cols="6" class="px-0 py-0">
                        <v-radio
                          class="label"
                          label="De Bac+3 à Bac+6"
                          :value="1"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--20">
                <ValidationProvider
                  rules="required"
                  name="Topic"
                  v-slot="{ errors }"
                >
                  <p class="label">Topic</p>
                  <v-text-field
                    outlined
                    hide-details="auto"
                    v-model="form.name"
                    required
                    class="mb-4"
                    :disabled="true"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" class="mt--15">
                <p class="label">Contenu</p>
                <textarea
                  id="ckeditor"
                  placeholder="Tapez votre textes…"
                  v-model="form.content"
                  rows="10"
                  cols="80"
                ></textarea>
              </v-col>
              <v-col cols="12" class="px-0 pt-2 mt--20">
                <v-checkbox
                        v-model="form.active"
                        :label="'Activation'"
                ></v-checkbox>
              </v-col>
              <v-col cols="12" class="py-3 mt--20">
                <v-btn
                  class="x-2"
                  color="primary"
                  type="submit"
                  rounded
                  depressed
                  >Sauvegarder</v-btn
                >
                <v-btn
                  class="px-2 ml-3"
                  color="gray"
                  rounded
                  depressed
                  @click="cancel"
                  >Annuler</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import majorService from "@/services/major";
import { mapState } from "vuex";
export default {
  name: "ResumeForm",
  props: {},
  data: () => ({
    file: null,
    reviewImage: "",
    topics: [],
    specialities: []
  }),
  computed: {
    ...mapState({
      form: state => state.major.major
    })
  },
  mounted() {
    // eslint-disable-next-line
    CKEDITOR.replace('ckeditor');
  },
  methods: {
    cancel() {
      this.$store.dispatch("resetNews");
      this.$router.push({
        name: "IndexResume",
        query: {
          tab: 1
        }
      });
    },
    async save() {
      // eslint-disable-next-line
      this.form.content = CKEDITOR.instances.ckeditor.getData();
      if (this.form.id) {
        let res = await majorService.update(this.form);
        if (res) {
          this.$router.push({
            name: "IndexResume",
            query: {
              tab: 1
            }
          });
        }
      } else {
        let res = await majorService.create(this.form);
        if (res) {
          this.$router.push({
            name: "IndexResume",
            query: {
              tab: 1
            }
          });
        }
      }
    }
  }
};
</script>
<style lang="sass">


</style>
